import React from "react";
import AirHome from "./airhome.svg";

function AirHomeIcon() {
  return <img src={AirHome} alt="air home " />;
}

export default AirHomeIcon;
